import { useMemo } from "react";

import { PaymentMethod } from "@/lib/gql/__generated__/graphql";

import type { LabelProps } from "@/components/ui/label/label";
import { Label } from "@/components/ui/label/label";

import { useConvertPaymentMethodText } from "../../_hooks";

type Props = {
	paymentMethod: PaymentMethod | null;
};

export const PaymentMethodLabel = ({ paymentMethod }: Props) => {
	const { onConvertPaymentMethodText } = useConvertPaymentMethodText();

	const labelText = useMemo(
		() => onConvertPaymentMethodText(paymentMethod),
		[onConvertPaymentMethodText, paymentMethod],
	);

	const variant = useMemo<LabelProps["variant"]>(() => {
		switch (paymentMethod) {
			case null:
				return "required";
			case PaymentMethod.Credit:
				return "link";
			case PaymentMethod.Local:
				return "pink";
			case PaymentMethod.Test:
				return "green";
			case PaymentMethod.Free:
				return "green";
			default:
				return "black";
		}
	}, [paymentMethod]);

	return <Label variant={variant} text={labelText} />;
};
